module.exports = __webpack_public_path__ + "img/gift.1cacd746.svg";